window.ACC = window.ACC || {};

(function() {
  var phLoaderClass = 'loader',
      isOneStore = $('.ph-isOneStore').html(),
      pcmsPriceClass = '.ph-final-price-pcms',
      hhsUsStoreId = 'hhs-philips-us',
      hhsCaStoreId = 'hhs-philips-ca',
      atpMsgDiv = '.ph-atpmsgdiv';

  ACC.decisionPageInfiniteLoader = {
    decisionpageitem: 'decisionpageitem',
    lazyLoadedItemClass: '.ph-lazyloaded-item',
    prodSearchName: 'ph-prodSearchName',
    dataProd: 'data-prod',
    decisionpageCards: 'decisionpageCards',
    prodSalesOrg: 'data-salesorg',
    $currentStoreId: $('#currentStoreId').val(),
    isSparepartClass: '.ph-product-isSpProduct',
    $userTypeVal: $('#usertype').val(),
    bindAll: function() {
      this.setObserver();
    },
    setObserver: function() {
      var container = document.querySelector('.ph-intersection-observer');

      function intersection() {
        var observer = new IntersectionObserver(function(entries) {
          entries.map(function(entry) {
            var isIntersecting = entry.isIntersecting;

            if (isIntersecting) {
              ACC.decisionPageInfiniteLoader.loadContentSmartly(container, observer);
              observer.observe(container);
            }

            return true;
          }, {
            root: null,
            rootMargin: '0px',
            threshold: 0
          });
        });

        observer.observe(container);
      }

      if ('IntersectionObserver' in window) {
        intersection();
      } else {
        $.getScript(ACC.config.commonResourcePath + '/philipsUI/src/js/vendor/intersection-observer.min.js', function() {
          intersection();
        });
      }
    },
    categoryPageJsonPath: function(pageLengths) {
      var categoryJsonUrl = '',
          basepath = window.location.protocol + '//' + window.location.host,
          relativePath = window.location.href.replace(basepath, '');

      if (relativePath.indexOf('/c/')) {
        var relativePathSplitted = relativePath.split('/c/');
        var categoryUrl = String(relativePathSplitted[0] + '/c/');
        var categoryName = String(relativePathSplitted[1]);

        if (categoryName.indexOf('?')) {
          categoryName = categoryName.split('?')[0];
        }

        if (categoryName.indexOf('#')) {
          categoryName = categoryName.split('#')[0];
        }

        var queryString = $('.ph-querystringvalue').val();
        var sortValue = $('.ph-sortoptions').val();

        categoryJsonUrl = categoryUrl + 'getProducts.json?categoryCode=' + categoryName + '&page=' + pageLengths + '&q=' + queryString + '&sort=' + sortValue + '&show=Page';
      }

      return categoryJsonUrl;
    },
    selectJsonURL: function(pageLengths) {
      var jsonUrlSelected = '';

      if ($('.ph-searchresultpage').length > 0) {
        var queryString = $('.ph-querystringvalue').val();
        var sortValue = $('.ph-sortoptions').val();

        jsonUrlSelected = '/search/getSearchResults.json?page=' + pageLengths + '&q=' + queryString + '&sort=' + sortValue + '&show=Page';
      } else {
        jsonUrlSelected = ACC.decisionPageInfiniteLoader.categoryPageJsonPath(pageLengths);
      }

      return jsonUrlSelected;
    },
    loadContentSmartly: function(container, observer) {
      var pageLength = $('.ph-decisionpage__cards').find('.ph-decisionpage__item').length / parseInt($('.decisionpage_items_perpage').val(), 10),
          numberOfPages = parseInt($('.ph-itemsshown').attr('data-pagenumber'), 10),
          pageLengths = Math.ceil(pageLength),
          initiated = parseInt($('.totalpages-available').attr('data-initiated'), 10);

      if (initiated < pageLengths && pageLengths < parseInt($('.totalpages-available').val(), 10)) {
        $('.totalpages-available').attr('data-initiated', pageLengths);
        $.ajax({
          url: ACC.config.contextPath + ACC.decisionPageInfiniteLoader.selectJsonURL(pageLengths),
          dataType: 'json',
          async: false,
          success: function(response) {
            response.results.map(ACC.decisionPageInfiniteLoader.processTemplating);

            var showPrice = $('.ph-showprice').val();

            if (String(showPrice) === 'true') {
              ACC.decisionPageInfiniteLoader.lazyLoadListingPageHhs(response.results);
            }
          }
        });
      } else {
        $('.ph-intersection-observer').hide();
      }

      observer.unobserve(container);

      if (pageLengths >= numberOfPages) {
        $('.ph-intersection-observer').remove();
      }
    },
    customTemplateAddToCart: function(tmpl) {
      var accessibilityTransAddToCart = $('.accessibilityTransAddToCart').text();
      var addtoCartButtonHtml = '<div class="ph-loader"></div>' +
      '<button type="button" data-productcode="" data-page="plp" class="ph-decisionpageconfigbutton hidden ph-m-0  ph-p-0 ph-orangebutton ' +
      'large ph-icon-shoppingcart ph-positive ph-float-left"></button>' +
      '<button type="button" class="addtocartButton hidden ph-orangebutton large ph-addtocart ph-addtocartcategory ph-icon-shoppingcart ' +
      'ph-positive ph-float-left out-of-stock ph-disabledbutton" disabled="true" aria-disabled="true" ' +
      'aria-label="' + accessibilityTransAddToCart + '"> </button>';

      tmpl.querySelector('.ph-decisionpage__addtocarholder').innerHTML = addtoCartButtonHtml;

      return tmpl;
    },
    customTemplatePolyFill: function(tmpl) {
      if (tmpl.querySelector('.ph-decisionpage__card')) {
        var phDecisionpageCard = tmpl.querySelector('.ph-decisionpage__card').getAttribute('class');

        tmpl.querySelector('.ph-decisionpage__card').setAttribute('class', phDecisionpageCard + ' ph-lazyloaded-item');
      }

      tmpl.querySelector('.ph-product-summaryinfo__wrapper').innerHTML = '';
      tmpl.querySelector('.ph-potential-promotion__banner').innerHTML = '';
      tmpl.querySelector('.ph-product-classifications__wrapper').innerHTML = '';

      if (tmpl.querySelector(atpMsgDiv)) {
        tmpl.querySelector(atpMsgDiv).innerHTML = '<p class="ph-atpmessage strong"></p>';
      }

      var phPrice = 'ph-price',
          currentStoreId = 'currentStoreId';

      if (tmpl.querySelector('.' + phPrice)) {
        if (String($('#' + currentStoreId).val()).indexOf('pcms') > -1) {
          tmpl.querySelector('.' + phPrice).innerHTML = '<s></s> <span class="ph-final-price-pcms"></span>';
        } else {
          tmpl.querySelector('.' + phPrice).innerHTML = '<s></s> <span class="ph-final-price-hhs"></span>';
        }
      }

      return ACC.decisionPageInfiniteLoader.itemOrderedBefore(tmpl);
    },
    itemOrderedBefore: function(tmpl) {
      var template = tmpl,
          wishlistListView = 'ph-decisionpage-whislist--listview',
          wishlistGridView = 'ph-decisionpage-whislist--gridview',
          itemOrderedListView = 'ph-decisionpage-items-ordered-before--listview',
          itemOrderedGridView = 'ph-decisionpage-items-ordered-before--gridview';

      if (template.querySelector('.' + wishlistListView)) {
        var whislistClassListView = template.querySelector('.' + wishlistListView).getAttribute('class');

        template.querySelector('.' + wishlistListView).setAttribute('class', whislistClassListView + ' hidden');
      }

      if (template.querySelector('.' + wishlistGridView)) {
        var whislistClassGridView = template.querySelector('.' + wishlistGridView).getAttribute('class');

        template.querySelector('.' + wishlistGridView).setAttribute('class', whislistClassGridView + ' hidden');
      }

      if (template.querySelector('.' + itemOrderedListView)) {
        var itemOrderedBeforeListView = template.querySelector('.' + itemOrderedListView).getAttribute('class');

        template.querySelector('.' + itemOrderedListView).setAttribute('class', itemOrderedBeforeListView + ' hidden');
      }

      if (template.querySelector('.' + itemOrderedGridView)) {
        var itemOrderedBeforeGridView = template.querySelector('.' + itemOrderedGridView).getAttribute('class');

        template.querySelector('.' + itemOrderedGridView).setAttribute('class', itemOrderedBeforeGridView + ' hidden');
      }

      return template;
    },
    configurationPopupStatus: function($product) {
      var isConfigurationMandatory = false;

      if ($product.productCharacteristics !== null) {
        $product.productCharacteristics.forEach(function(characteristics) {
          if (characteristics.isMandatory === true) {
            isConfigurationMandatory = true;
          }
        });
      }

      return isConfigurationMandatory;
    },
    configurableStatus: function($product) {
      var isConfigurable = false;

      if (String($product.productCharacteristics) !== 'null' && $product.productCharacteristics.length > 0) {
        isConfigurable = true;
      }

      return isConfigurable;
    },
    identifyConfigurableItem: function($product) {
      var autoConfigCounter = 0,
          isAutoConfig = false,
          isConfigurable = false,
          $outofStockDiv = $('#productOutofstock_' + $product.code),
          isConfigurableProduct = false;

      if (String($product.productCharacteristics) !== 'null' && $product.productCharacteristics.length > 0) {
        $product.productCharacteristics.forEach(function(characteristics) {
          if (characteristics.readOnly === true) {
            autoConfigCounter = autoConfigCounter + 1;
          }
        });
        isConfigurable = true;
      }

      if ($product.productCharacteristics && $product.productCharacteristics.length === autoConfigCounter) {
        isAutoConfig = true;
      }

      if (isConfigurable === true && isAutoConfig === false) {
        $outofStockDiv.html($('.ph-config_product_msg').text());
        isConfigurableProduct = true;
      }

      $outofStockDiv.attr('isConfigurableProduct', String(isConfigurableProduct));

      return isConfigurableProduct;
    },
    getTmplNode: function($product) {
      var tmpl = {};

      if ('content' in document.createElement('template')) {
        tmpl = document.getElementById('decisionPageProductTemplate').content.cloneNode(true);
        tmpl.querySelector('.ph-decisionpage__item').setAttribute('id', ACC.decisionPageInfiniteLoader.decisionpageitem + $product.code);
      } else {
        if (document.getElementById('decisionPageProductTemplate') && document.getElementById('decisionPageProductTemplate').querySelector('.ph-decisionpage__item').cloneNode(true)) {
          tmpl = document.getElementById('decisionPageProductTemplate').querySelector('.ph-decisionpage__item').cloneNode(true);
        } else {
          tmpl = document.getElementById('decisionpageCards').querySelector('.ph-decisionpage__item').cloneNode(true);
        }

        if (window.NodeList && !NodeList.prototype.forEach) {
          NodeList.prototype.forEach = Array.prototype.forEach;
        }

        tmpl = ACC.decisionPageInfiniteLoader.customTemplatePolyFill(tmpl);
        tmpl.setAttribute('id', ACC.decisionPageInfiniteLoader.decisionpageitem + $product.code);
        tmpl = ACC.decisionPageInfiniteLoader.customTemplateAddToCart(tmpl);

        if (tmpl.querySelector('.ph-product__outofstock')) {
          tmpl.querySelector('.ph-product__outofstock').setAttribute('class', 'ph-product__outofstock hidden');
        }
      }

      tmpl = ACC.decisionPageInfiniteLoader.additionalTmplEntry(tmpl, $product);

      return tmpl;
    },
    additionalTmplEntry: function(tmpl, $product) {
      if (typeof tmpl.querySelector('button[data-islumify]') !== 'undefined' && typeof $product.isInnosightProduct !== 'undefined') {
        tmpl.querySelector('button[data-islumify]').setAttribute('data-islumify', $product.isInnosightProduct);
      }

      if (typeof tmpl.querySelector('button[data-isInnosight]') !== 'undefined' && typeof $product.isInnosightProduct !== 'undefined') {
        tmpl.querySelector('button[data-isInnosight]').setAttribute('data-isInnosight', $product.isInnosightProduct);
      }

      return tmpl;
    },
    anonymousUserButtonHtml: function($decisionpageCards, $product) {
      $decisionpageCards.find('#' + ACC.decisionPageInfiniteLoader.decisionpageitem + $product.code).find('.ph-decisionpage__bottomcontent').remove();

      var $anonyDecisionpageBottom = $decisionpageCards.find('#' + ACC.decisionPageInfiniteLoader.decisionpageitem + $product.code)
        .find('.ph-anonyDecisionpage_bottomcontent');

      $anonyDecisionpageBottom.removeClass('hidden');
      $anonyDecisionpageBottom.find('.ph-anonyAddToCartAnchor').attr('href', $product.url);
    },
    processTemplating: function($product) {
      var $decisionpageCards = $('#decisionpageCards'),
          tmpl = ACC.decisionPageInfiniteLoader.getTmplNode($product),
          isAnonymousSaleAllowed = false;

      if ($product.isAnonymousSaleAllowed && $product.isAnonymousSaleAllowed === true) {
        isAnonymousSaleAllowed = true;
      }

      tmpl = ACC.decisionPageInfiniteLoader.productTopContent(tmpl, $product);
      tmpl = ACC.decisionPageInfiniteLoader.decisionPageInfo(tmpl, $product);
      tmpl = ACC.decisionPageInfiniteLoader.decisionPageClassification(tmpl, $product);

      if (ACC.decisionPageInfiniteLoader.$userTypeVal === 'CUSTOMERGROUP') {
        tmpl = ACC.decisionPageInfiniteLoader.decisionPageAtpMsg(tmpl, $product);
        tmpl = ACC.decisionPageInfiniteLoader.decisionPageFavIcon(tmpl, $product);
      }

      if (ACC.decisionPageInfiniteLoader.$userTypeVal === 'CUSTOMERGROUP' || isAnonymousSaleAllowed === true) {
        tmpl = ACC.decisionPageInfiniteLoader.decisionPagePrice(tmpl, $product, isAnonymousSaleAllowed);
        tmpl = ACC.decisionPageInfiniteLoader.decisionPageFormInput(tmpl, $product);
        tmpl = ACC.decisionPageInfiniteLoader.decisionPageAddtoCart(tmpl, $product);
      }

      $decisionpageCards.append(tmpl);

      if (ACC.decisionPageInfiniteLoader.$userTypeVal !== 'CUSTOMERGROUP' && isAnonymousSaleAllowed === false) {
        ACC.decisionPageInfiniteLoader.anonymousUserButtonHtml($decisionpageCards, $product);
      } else {
        // User is logged in. Also we are passing latest added product to #decisionpageCards from tmpl
        ACC.decisionPageInfiniteLoader.sparepartRibbonCheck($decisionpageCards.children().last());
      }

      if ($(document).find('.ph-add2cart-formload').length > 0) {
        $(document).find('.ph-add2cart-formload').removeClass('ph-add2cart-formload');
      }

      ACC.decisionPageInfiniteLoader.triggerLazyloadItem($decisionpageCards, $product);
    },
    sparepartRibbonCheck: function($product) {
      var isSpProduct = $product.find(ACC.decisionPageInfiniteLoader.isSparepartClass).val(),
          ribbonText = $product.find('.ph-promotion-ribbon-inner').text().trim(),
          $loggedinUser = $('.ph-loggedInPage__genericClass'),
          ribbonEmptyorNull = ribbonText === '' || ribbonText === 'null';

      if ($loggedinUser.length === 0 || isSpProduct === 'false' || ribbonEmptyorNull) {
        $product.find('.ph-promotion-ribbon').remove();
      } else {
        $product.find('.ph-promotion-ribbon').show();
      }
    },
    triggerLazyloadItem: function($decisionpageCards, $product) {
      if ($(document).find('.template-pages-layout-landingLayout1Page').length === 0) {
        $(document).find('.add_to_cart_form').each(function() {
          ACC.product.addTocartFormValidation($(this));
        });
      }

      var isConfigurableProduct = ACC.decisionPageInfiniteLoader.identifyConfigurableItem($product);

      if (isOneStore !== 'true' && $decisionpageCards.find('#decisionpageitem' + $product.code).find(pcmsPriceClass).length > 0) {
        ACC.decisionPageInfiniteLoader.lazyLoadListingPage(isConfigurableProduct, $product.code);
      }

      if ($product.isConfigitEnabled) {
        ACC.configit.plpConfigitButton($product.code, $product.salesOrg);
      }

      if ($product.isIGDTProduct) {
        ACC.decisionPageInfiniteLoader.igtdWrapper($decisionpageCards.find('#decisionpageitem' + $product.code), $product.code);
      }

      ACC.decisionPageInfiniteLoader.renderDuplicateHandle($decisionpageCards, $product);
    },
    igtdWrapper: function($this, productCode) {
      var newClassName = 'igtdProduct' + productCode;

      $this.find('.ph-igtd_product_message').removeClass('ph-d-none').addClass(newClassName);
      $this.find('.ph-atpmsgdiv').addClass('ph-d-none');
    },
    productTopContent: function(tmpl, $product) {
      ACC.decisionPageInfiniteLoader.renderOrderedBeforeContent(tmpl, $product);

      var productAnchorDomItem = tmpl.querySelector('.ph-decision-page__topcontent > a');

      productAnchorDomItem.setAttribute('data-productimg', $product.code);
      productAnchorDomItem.setAttribute('href', $product.url);
      productAnchorDomItem.setAttribute('title', $product.name);

      var imageUrl = '/_ui/desktop/common/philipsUI/src/images/no-image-130x130.gif';

      if (String($product.imageURL) !== 'null' && String($product.imageURL) !== '') {
        imageUrl = $product.imageURL + '?wid=130&hei=130&$jpgsmall$';
      }

      var imageContainerDomItems = tmpl.querySelectorAll('.ph-decisionpage__image img');

      imageContainerDomItems.forEach(function(imageContainerDomItem) {
        imageContainerDomItem.setAttribute('title', $product.name);
        imageContainerDomItem.setAttribute('src', imageUrl);
        imageContainerDomItem.setAttribute('alt', $product.name);
      });

      return tmpl;
    },
    renderOrderedBeforeContent: function(tmpl, $product) {
      var orderedBeforeContentItems = tmpl.querySelectorAll('.ph-items-ordered-before');

      orderedBeforeContentItems.forEach(function(item) {
        var orderedItemLink = item.querySelector('.ph-orderedItem-link'),
            orderedItemQty = item.querySelector('.ph-orderedItem-qty'),
            orderedItemCreatedDate = item.querySelector('.ph-orderedItem-createdDate'),
            orderedItemShippedDate = item.querySelector('.ph-orderedItem-shippedDate'),
            orderedItemShippedDateWrapper = item.querySelector('.ph-orderedItem-shippedDateWrapper');

        if ($product.recentOrderProdQuantity && $product.recentOrderCreatedDate) {
          item.classList.remove('hidden');
          orderedItemLink.setAttribute('href', '/my-account/orders?orderCode=' + $product.recentOrderId + '#' + $product.recentOrderId);
          orderedItemQty.innerHTML = $product.recentOrderProdQuantity;
          orderedItemCreatedDate.innerHTML = $product.recentOrderCreatedDate;
          orderedItemShippedDate.innerHTML = $product.recentOrderShippedDate;
        }

        if ($product.recentOrderShippedDate && $product.recentOrderShippedDate !== '') {
          orderedItemShippedDateWrapper.classList.remove('hidden');
        }
      });
    },
    googleAnalytics: function(tmpl, $product) {
      var isCategoryPage = document.querySelector('.ph-page-productList'),
          isSearchPage = document.querySelector('.ph-page-search'),
          listName = '',
          currentIndex = parseInt($('.current_index_plp').text(), 10),
          decisonPageCardClass = '.ph-decisionpage__card';

      currentIndex = currentIndex + 1;
      $('.current_index_plp').text(String(currentIndex));

      if (isCategoryPage) {
        listName = 'Category_' + document.querySelector('.ph-headerparent__categorycode').innerText;
      } else if (isSearchPage) {
        listName = 'searchResults';
      }

      tmpl.querySelector(decisonPageCardClass).setAttribute('data-ctn', $product.ctn);
      tmpl.querySelector(decisonPageCardClass).setAttribute('data-list-name', listName);
      tmpl.querySelector(decisonPageCardClass).setAttribute('data-list-position', currentIndex);
    },
    newProdAttributes: function(tmpl, $product) {
      var prodlistClass = '.prod_list',
          havingprice = '';

      tmpl.querySelector('.ph-decision-page__specialwrap').setAttribute('data-productid', $product.ctn);

      if ($product.price && $product.price.value && $product.price.value > 0) {
        havingprice = 'true';
      }

      tmpl.querySelector(prodlistClass).setAttribute('data-approval', $product.approval);
      tmpl.querySelector(prodlistClass).setAttribute('data-price', havingprice);

      if ($product.salesOrg) {
        tmpl.querySelector(prodlistClass).setAttribute(ACC.decisionPageInfiniteLoader.prodSalesOrg, $product.salesOrg);
      }
    },
    decisionPageInfo: function(tmpl, $product) {
      var ctnValue = $product.ctn,
          productNameDisplay = '';

      if (String($product.code) !== 'null' && String($product.code) !== '' && String($product.code) !== String($product.ctn)) {
        ctnValue = $product.ctn + '&nbsp;/' + $product.code;
      }

      tmpl.querySelector('.ph-ctn').innerHTML = ctnValue;
      tmpl.querySelector('.ph-ctn').setAttribute('data-productid', $product.ctn);
      tmpl.querySelector('.ph-productname').setAttribute(ACC.decisionPageInfiniteLoader.dataProd, $product.code);

      ACC.decisionPageInfiniteLoader.newProdAttributes(tmpl, $product);
      ACC.decisionPageInfiniteLoader.googleAnalytics(tmpl, $product);

      if ($product.summary) {
        tmpl.querySelector('.ph-product-summaryinfo__wrapper').innerHTML = '<p class="ph-product-summaryinfo">' + $product.summary + '</p>';
      }

      if ($product.salesOrg) {
        tmpl.querySelector('.ph-productname').setAttribute(ACC.decisionPageInfiniteLoader.prodSalesOrg, $product.salesOrg);
      }

      if ($product.prxProductName && $.trim($product.prxProductName) !== $.trim($product.summary)) {
        productNameDisplay = $product.prxProductName;
      } else if ($product.name && $.trim($product.name) !== $.trim($product.summary)) {
        productNameDisplay = $product.name;
      }

      tmpl.querySelector('.ph-productname').innerHTML = '<span>' + productNameDisplay + '</span>';

      return tmpl;
    },
    decisionPageClassification: function(tmpl, $product) {
      var classificationData = '';

      if (String($product.classifications) !== 'undefined' && String($product.classifications) !== 'null' && String($product.classifications) !== '') {
        classificationData = classificationData + '<ul class="product-classification">';
        $product.classifications.forEach(function(classification) {
          var subClassificationData = ACC.decisionPageInfiniteLoader.subClassification(classification);

          classificationData = classificationData + '<li><strong>' + classification.name + '</strong>' + subClassificationData + '</li>';
        });
        classificationData = classificationData + '</ul>';
      }

      tmpl.querySelector('.ph-product-classifications__wrapper').innerHTML = classificationData;

      return tmpl;
    },
    subClassification: function(classification) {
      var subClassificationData = '';

      if (String(classification.features) !== 'undefined' && String(classification.features) !== 'null' && String(classification.features) !== '') {
        subClassificationData = subClassificationData + '<ul class="product-classification">';
        classification.features.forEach(function(feature) {
          var featureData = ACC.decisionPageInfiniteLoader.features(feature);

          subClassificationData = subClassificationData + '<li><strong>' + feature.name + '</strong>' + featureData + '</li>';
        });
        subClassificationData = subClassificationData + '</ul>';
      }

      return subClassificationData;
    },
    features: function(feature) {
      var featureData = '';

      if (String(feature.featureValues) !== 'undefined' && String(feature.featureValues) !== 'null' && String(feature.featureValues) !== '') {
        featureData = featureData + '<span>';
        feature.featureValues.forEach(function(featureValue) {
          if (featureValue.value !== 'undefined') {
            featureData = featureData + '<span>' + featureValue.value + '&nbsp;</span>';
          }

          if (featureValue.featureUnit !== 'undefined' && featureValue.featureUnit.symbol !== 'undefined') {
            featureData = featureData + '<span>' + feature.featureUnit.symbol + '&nbsp;</span>';
          }
        });
        featureData = featureData + '</span>';
      }

      return featureData;
    },
    hazardousCheck: function($product) {
      if ($product.isSpProduct !== true && String($product.hazardousCode) === String($('.ph-atpvar-atpHazardousCode').text())) {
        return true;
      }

      return false;
    },
    decisionPageAtpMsg: function(tmpl, $product) {
      var atpmsgdiv = '',
          atpData = $product.philipsATPData,
          atpmsgdivContent = '';

      if (atpData && (typeof atpData.isError !== 'undefined' && String(atpData.isError) === 'true')) {
        var atpvaratpmsg = String($('.ph-atpvar-atpmsg').text());

        if (atpvaratpmsg.trim() !== 'null') {
          atpmsgdiv = '<p class="ph-atpmessage strong ">' + atpvaratpmsg + '</p>';
        }
      } else if (ACC.decisionPageInfiniteLoader.hazardousCheck($product) && (atpData && String(atpData.isProductInStock) === 'true')) {
        atpmsgdiv = '<p class="ph-atpmessage atpHazardousCode strong ">' + $('.ph-atpvar-atpHazardousTextInstockMsg').html() + '</p>';
      } else {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditions($product, atpData);
      }

      atpmsgdivContent = ACC.decisionPageInfiniteLoader.displayLeadtime($product, atpmsgdiv);

      if (atpmsgdivContent !== '') {
        tmpl.querySelector(atpMsgDiv).innerHTML = atpmsgdivContent;
        tmpl.querySelector(atpMsgDiv).classList.remove('hidden');
      }

      return tmpl;
    },
    displayLeadtime: function($product, atpmsgdiv) {
      var atpmsgdivContent = '';

      if ($('.ph-checkATPEnabled').html() === 'true') {
        atpmsgdivContent = atpmsgdiv;
      } else if (ACC.decisionPageInfiniteLoader.$currentStoreId === hhsUsStoreId ||
                 ACC.decisionPageInfiniteLoader.$currentStoreId === hhsCaStoreId ||
      $('.ph-showAdditionalCost').html() === 'true') {
        if ($product.leadTime !== null && $product.leadTime > 0) {
          atpmsgdivContent = ACC.decisionPageInfiniteLoader.atpConditionsleadTime($product);
        }
      }

      return $.trim(atpmsgdivContent);
    },
    atpConditions: function($product, atpData) {
      var atpmsgdiv = '',
          atpvaratpmsg = String($('.ph-atpvar-atpmsg').text()),
          isAtpIdentifier = '';

      if ($product.atpIdentifier && $product.atpIdentifier !== 'NA') {
        isAtpIdentifier = true;
      } else {
        isAtpIdentifier = false;
      }

      if (atpvaratpmsg.trim() !== 'null') {
        atpmsgdiv = '<p class="ph-atpmessage strong ">' + atpvaratpmsg + '</p>';
      }


      if (isAtpIdentifier === true && atpData && String(atpData.isProductInStock) === 'true') {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpEstimatedDateRange($product);
      } else if (atpData && String(atpData.isProductInStock) !== 'true') {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditionsProductNotInStock($product);
      }

      if (isAtpIdentifier === false) {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditionsNoIdentifier(atpmsgdiv, $product);
      }

      return atpmsgdiv;
    },
    atpEstimatedDateRange: function($product) {
      var deliveryDateValue = '';
      var instockDeliveryRange = String($('.ph-atpvar-instockDeliveryRange').text());

      if ($product.philipsATPData && $product.philipsATPData.estimateDeliveryDate && $product.philipsATPData.estimateDeliveryDate !== '') {
        deliveryDateValue = $product.philipsATPData.estimateDeliveryDate;
      }

      return '<p class="ph-atpmessage strong ph-atpidentifier">' + instockDeliveryRange + ' ' + deliveryDateValue + '</p>';
    },
    atpConditionsNoIdentifier: function(atpmsgdivInput, $product) {
      var atpmsgdiv = atpmsgdivInput;

      if ($product.leadTime !== null && $product.leadTime > 0) {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditionsleadTime($product);
      } else if (isOneStore === 'true' && $product.philipsATPData && String($product.philipsATPData.isProductInStock) === 'true') {
        if ($product.isSpProduct === true && $product.philipsATPData.estimateDeliveryDate) {
          atpmsgdiv = ACC.decisionPageInfiniteLoader.atpEstimatedDateRange($product);
        } else if ($product.isSpProduct === true) {
          atpmsgdiv = '<p class="ph-atpmessage strong ph-atpNoidentifier atpinstock">' + $('.ph-inStock').html() + '</p>';
        }
      }

      return atpmsgdiv;
    },
    atpConditionsleadTime: function($product) {
      var atpvarAtpleadTime = String($('.ph-atpvar-atpleadTime').html()),
          atpleadTimeMsg = '';

      if (atpvarAtpleadTime.indexOf('{0}')) {
        atpvarAtpleadTime = atpvarAtpleadTime.replace('{0}', $product.leadTime);
      }

      if ((ACC.decisionPageInfiniteLoader.$currentStoreId === hhsUsStoreId ||
           ACC.decisionPageInfiniteLoader.$currentStoreId === hhsCaStoreId) &&
          !$product.isAtpCall) {
        atpleadTimeMsg = '<p class="ph-atpmessage strong ph-atpleadtime ph-plp_product_leadtime hidden">' + atpvarAtpleadTime + '</p>';
      } else {
        atpleadTimeMsg = '<p class="ph-atpmessage strong ph-atpleadtime ">' + atpvarAtpleadTime + '</p>';
      }

      return atpleadTimeMsg;
    },
    checkAtpIdentifier: function(atpIdentifier) {
      return atpIdentifier && (String(atpIdentifier) === 'MCP' || String(atpIdentifier) === 'PRD');
    },
    atpNotInStockSps: function(atpData) {
      var atpmsgdiv = '<p class="its_sps ph-atpmessage strong">' +
      $('.ph-outofStock').text() +
      '</p>';

      if (atpData && atpData.outOfStockEstimateDeliveryDate && atpData.outOfStockEstimateDeliveryDate !== '') {
        atpmsgdiv = '<p class="its_sps oos_edd strong ph-atpmessage">' +
            $('.ph-atpvar-outofStockDeliveryRange').text() + ' ' + atpData.outOfStockEstimateDeliveryDate +
            '</p>';
      }

      return atpmsgdiv;
    },
    atpConditionsProductNotInStock: function($product) {
      var atpmsgdiv = '',
          rdcDeliveryDateValue = '',
          atpData = $product.philipsATPData;

      if (atpData && atpData.estimateDeliveryDate && atpData.estimateDeliveryDate !== '') {
        rdcDeliveryDateValue = atpData.estimateDeliveryDate;
      }

      if ($product.atpIdentifier && String($product.atpIdentifier) === 'MP1' && rdcDeliveryDateValue !== '') {
        atpmsgdiv = '<p class="oos_rdc_edd ph-atpmessage strong">' +
            $('.ph-atpvar-rdcDeliveryRange').text() + ' ' + rdcDeliveryDateValue +
            '</p>';
      } else if ($product.isSpProduct === true) {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpNotInStockSps(atpData);
      } else if (isOneStore !== 'true' || ACC.decisionPageInfiniteLoader.checkAtpIdentifier($product.atpIdentifier)) {
        atpmsgdiv = '<p class="its_prd_or_mcp ph-atpmessage strong">' +
            $('.ph-atpvar-outofstockmsg').text() +
            '</p>';
      }

      atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditionsNoStock2(atpmsgdiv);

      return atpmsgdiv;
    },
    atpConditionsNoStock2: function(atpmsgdivInput) {
      var atpmsgdiv = atpmsgdivInput;

      if ($('.ph-atpvar-page2').text() === 'CHECKOUT') {
        atpmsgdiv = '<p class="ph-atpmessage strong ph-atpincheckout">' + $('.ph-atpvar-checkoutOutofstockMessage').text() + '</p>';
      } else if ($('.ph-atpvar-page1').text() === 'CART') {
        atpmsgdiv = '<p class="ph-atpmessage strong ph-atpincart">' + $('.ph-atpvar-cartoutofstockmsg').text() + '</p>';
      }

      return atpmsgdiv;
    },
    decisionPagePrice: function(tmpl, $product, isAnonymousSaleAllowed) {
      if (String($product.purchasable) === 'true' || isAnonymousSaleAllowed === true) {
        tmpl.querySelector('.ph-qtylabeltext').classList.remove('hidden');
      }

      if (String($product.volumePricesFlag) === 'true') {
        tmpl.querySelector('.volumePricesFlag').classList.remove('hidden');
      }

      if ($product.price && $product.price.value && $product.price.value > 0) {
        var phPrice = 'ph-price',
            currentStoreId = 'currentStoreId';

        if (String($('#' + currentStoreId).val()).indexOf('pcms') > -1) {
          tmpl.querySelector('.' + phPrice).innerHTML = '<s></s> <span class="ph-final-price-pcms">' + $product.price.formattedValue + '</span>';
        } else {
          tmpl.querySelector('.' + phPrice).innerHTML = '<s></s> <span class="ph-final-price-hhs">' + $product.price.formattedValue + '</span>';
        }
      }

      ACC.decisionPageInfiniteLoader.hidePriceForUser(tmpl);

      return tmpl;
    },
    decisionPageFavIcon: function(tmpl, $product) {
      if (tmpl.querySelector('.ph-addshoppinglistbtn')) {
        tmpl.querySelector('.ph-addshoppinglistbtn').setAttribute('data-productcode', $product.code);
        tmpl.querySelector('.ph-addshoppinglistbtn').setAttribute('data-product', $product.ctn);
      }

      tmpl.querySelector('.ph-addtoshoppinglist-container').setAttribute('id', 'addtoshoppinglist-container-' + $product.code);
      tmpl.querySelector('.ph-addtoshoppinglist').setAttribute('data-productcode', $product.code);

      if (tmpl.querySelectorAll('.ph-shoppinglistRdo')) {
        tmpl.querySelectorAll('.ph-shoppinglistRdo').forEach(function(shoppinglistRdo) {
          shoppinglistRdo.setAttribute('id', 'ph-shoppinglistRdo-' + $product.code);
        });
      }

      tmpl.querySelector('.ph-newlistinputcheck').setAttribute('id', 'ph-shoppinglistRdo-' + $product.code);
      tmpl.querySelector('.ph-newlistfield_removedisable').setAttribute('id', 'ph-newList-' + $product.code);
      tmpl.querySelector('.ph-savetolistBtn').setAttribute('data-productcode', $product.code);
      tmpl.querySelector('.addToShoppingListProductCode').value = $product.code;

      return tmpl;
    },
    decisionPageFormInput: function(tmpl, $product) {
      tmpl.querySelector('.productcode-postable').value = $product.code;

      if ($product.salesOrg) {
        tmpl.querySelector('.ph-product-salesOrg').value = $product.salesOrg;
      }

      tmpl.querySelector(ACC.decisionPageInfiniteLoader.isSparepartClass).value = $product.isSpProduct;

      if (tmpl.querySelector('.ph-addtocartform')) {
        tmpl.querySelector('.ph-addtocartform').setAttribute('id', 'addToCartForm' + $product.code);
      }

      if (tmpl.querySelector('.ph-product__outofstock')) {
        tmpl.querySelector('.ph-product__outofstock').setAttribute('id', 'productOutofstock_' + $product.code);
      }

      return tmpl;
    },
    decisionPageAddtoCart: function(tmpl, $product) {
      var validPrice = true,
          approvalRohOrObsolete = String($product.approval) === 'regulatoryonhold' || String($product.approval) === 'obsolete';

      if (String($product.price) === 'undefined' || $product.price === '' || String($product.price) === 'null') {
        validPrice = false;
      }

      if (!((String($product.stock.stockLevelStatus.code) === 'outOfStock') || validPrice === false || approvalRohOrObsolete)) {
        var buttonType = 'submit';

        tmpl.querySelector('.addtocartButton').setAttribute('type', buttonType);
        tmpl.querySelector('.addtocartButton').classList.remove('out-of-stock');
        tmpl.querySelector('.addtocartButton').classList.remove('ph-disabledbutton');
        tmpl.querySelector('.addtocartButton').removeAttribute('disabled');
        tmpl.querySelector('.addtocartButton').removeAttribute('aria-disabled');
      }

      // There is no lumifyConfig in productListerItemTemplate.tag file. So below code is not used at all.
      if ($('#lumifyConfig' + $product.code).attr('data-istransducer') === 'true') {
        tmpl.querySelector('.addtocartButton').setAttribute('type', 'button');
        $('.addtocartButton').addClass('ph-lumifyconfigurelink');
      }

      if (tmpl.querySelector('.ph-loader')) {
        tmpl.querySelector('.ph-loader').classList.remove('hidden');
      }

      return tmpl;
    },
    ajaxHhsPcms: function($this, result) {
      var $othis = $this;

      if (result.wishListName) {
        var wishListNames = result.wishListName,
            wishListUrl = '';

        wishListUrl = wishListNames.split(' ').join('');

        $othis.find('.ph-' + phLoaderClass).removeClass('hidden');
        $othis.find('.ph-whislist__parent').removeClass('hidden');
        $othis.find('.ph-wishlistname').html(wishListNames);
        $othis.find('.ph-wishlistname').attr('title', wishListNames);
        $othis.find('.ph-wishlistname').attr('href', '/shoppingList#' + wishListUrl);
      }
    },
    renderAddtocartButton: function(result, $othis, booleanObj) {
      $othis.find('.ph-' + phLoaderClass).addClass('hidden');
      $othis.find('.addtocartButton').removeClass('hidden');

      if (booleanObj.isSparePart === 'true') {
        ACC.decisionPageInfiniteLoader.enableAddtocartButton($othis, true, result.stock.stockLevelStatus.code !== 'outOfStock');
      } else if (!result.isLumifyProduct && booleanObj.isConfigurableProduct) {
        $othis.find('.ph-' + phLoaderClass).addClass('hidden');
        $othis.find('.ph-decisionpageconfigbutton').removeClass('hidden');
        $othis.find('button.addtocartButton').addClass('hidden');
        $othis.find('.ph-decision-page__price').addClass('hidden');

        if (result.code !== null) {
          $othis.find('.ph-decisionpageconfigbutton').attr('data-productcode', result.code);
        }

        ACC.decisionPageInfiniteLoader.enableAddtocartButton($othis, true, false);
      } else {
        var isEnable = booleanObj.havePrice && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock' && result.approval === 'approved';

        ACC.decisionPageInfiniteLoader.enableAddtocartButton($othis, isEnable, result.stock.stockLevelStatus.code !== 'outOfStock', result.approval);
        ACC.pdp.igtdMessageDisplay(result.code);
      }

      if (!booleanObj.havePrice) {
        $othis.find('.ph-qtylabeltext').addClass('hidden');
      }
    },
    enableAddtocartButton: function($othis, isEnable, isStock, approvalStatus) {
      var outOfStockClass = '.ph-product__outofstock',
          addToCartButtonClass = '.addtocartButton';

      if (isEnable) {
        $othis.find(outOfStockClass).addClass('hidden');
        $othis.find(addToCartButtonClass).attr('disabled', false);
        $othis.find(addToCartButtonClass).removeClass('out-of-stock ph-disabledbutton');
        $othis.find(addToCartButtonClass).prop('type', 'submit');
        $othis.find(addToCartButtonClass).attr('aria-disabled', false);
      } else {
        $othis.find(outOfStockClass).removeClass('hidden');
        $othis.find('.ph-atpmessage').addClass('hidden');
      }

      if (!isStock) {
        $othis.find(outOfStockClass).removeClass('hidden');
      }

      if (approvalStatus === 'obsolete') {
        $othis.find(outOfStockClass).addClass('hidden');
        $othis.find('.plpproduct_ObsoleteMessage').removeClass('hidden');
      }
    },
    renderAddtocartButtonHhs: function(result, element, havePrice, isConfigurableProduct) {
      if (isConfigurableProduct && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock') {
        $(element).find('.ph-' + phLoaderClass).addClass('hidden');
        $(element).find('.ph-decisionpageconfigbutton').removeClass('hidden');
        $(element).find('.ph-decisionpageconfigbutton').attr('data-productcode', result.code);
        // Unhide config message 'Please add to cart and configure item for price'
        $(element).find('.ph-product__outofstock').removeClass('hidden');
      } else {
        $(element).find('.ph-' + phLoaderClass).addClass('hidden');
        $(element).find('.addtocartButton').removeClass('hidden');

        if (havePrice && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock' && result.approval === 'approved') {
          $(element).find('.ph-product__outofstock').addClass('hidden');
          $(element).find('.addtocartButton').attr('disabled', false);
          $(element).find('.addtocartButton').removeClass('out-of-stock ph-disabledbutton');
          $(element).find('.addtocartButton').prop('type', 'submit').attr('aria-disabled', false);
          $(element).find('.ph-plp_product_leadtime').removeClass('hidden');
          ACC.pdp.igtdMessageDisplay(result.code);
        } else {
          if (result.approval === 'obsolete') {
            $(element).find('.plpproduct_ObsoleteMessage').removeClass('hidden');
          } else {
            $(element).find('.ph-product__outofstock').removeClass('hidden');
          }

          $(element).find('.ph-atpmessage').addClass('hidden');
        }
      }

      if (!havePrice) {
        $(element).find('.ph-qtylabeltext').addClass('hidden');
      }
    },
    setStrikeoutPrice: function($othis, result) {
      if (result.price.formattedValue && result.price.formattedFinalValue && result.price.formattedValue !== result.price.formattedFinalValue) {
        $othis.find('s').text(result.price.formattedValue);
      }
    },
    setPriceDetails: function($othis, result) {
      var havePrice = false,
          phfinalpricepcms = 'ph-final-price-pcms';

      if ($othis.find('s').length > 0 && result.price !== null && result.price.formattedFinalValue) {
        ACC.decisionPageInfiniteLoader.setStrikeoutPrice($othis, result);
        $othis.find('.' + phfinalpricepcms).text(result.price.formattedFinalValue);
        havePrice = true;
      } else if (result.price !== null && result.price.formattedFinalValue) {
        $othis.find('.' + phfinalpricepcms).text(result.price.formattedFinalValue);
        havePrice = true;
      } else if (result.price !== null && result.price.formattedValue) {
        $othis.find('.' + phfinalpricepcms).text(result.price.formattedValue);
        havePrice = true;
      }

      return havePrice;
    },
    lazyLoadListingPage: function(isConfigurableProduct, productId) {
      var $othis = $('#' + ACC.decisionPageInfiniteLoader.decisionpageitem + productId).find('.ph-decisionpage__card'),
          currentCtn = $othis.find('.' + ACC.decisionPageInfiniteLoader.prodSearchName).attr(ACC.decisionPageInfiniteLoader.dataProd),
          isSpProduct = $othis.closest('.ph-decisionpage__item').find(ACC.decisionPageInfiniteLoader.isSparepartClass).val();

      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + '/lazyload/getpricedata',
        dataType: 'json',
        data: {
          code: currentCtn,
          isSparePart: isSpProduct
        },
        success: function(result) {
          var booleanObj = {
            havePrice: false,
            isConfigurableProduct: isConfigurableProduct,
            isSparePart: isSpProduct
          };

          if (result.price !== null) {
            booleanObj.havePrice = ACC.decisionPageInfiniteLoader.setPriceDetails($othis, result);
          }

          ACC.decisionPageInfiniteLoader.ajaxHhsPcms($othis, result);
          ACC.decisionPageInfiniteLoader.renderAddtocartButton(result, $othis, booleanObj);

          $('#' + ACC.decisionPageInfiniteLoader.decisionpageCards).find(ACC.decisionPageInfiniteLoader.lazyLoadedItemClass).removeClass('ph-lazyloaded-item');
        }
      });
    },

    lazyLoadListingPageHhsSubFunction: function($this, result, finalPriceClass) {
      var havePrice = false;

      if ($this.find('s').length > 0 && result.price !== null && result.price.formattedFinalValue) {
        ACC.decisionPageInfiniteLoader.setStrikeoutPrice($this, result);
        $this.find(finalPriceClass).text(result.price.formattedFinalValue);
        havePrice = true;
      } else if (result.price !== null && result.price.formattedFinalValue) {
        $this.find(finalPriceClass).text(result.price.formattedFinalValue);
        havePrice = true;
      } else if (result.price !== null && result.price.formattedValue) {
        $this.find(finalPriceClass).text(result.price.formattedValue);
        havePrice = true;
        ACC.decisionPageInfiniteLoader.estDeliveryHhsResultDate(result);
      }

      return havePrice;
    },

    lazyLoadListingPageHhsMainFunction: function(result, cardResponse) {
      $('#' + ACC.decisionPageInfiniteLoader.decisionpageCards).find(ACC.decisionPageInfiniteLoader.lazyLoadedItemClass).each(function() {
        var $this = $(this),
            ctn = $this.find('.' + ACC.decisionPageInfiniteLoader.prodSearchName).attr(ACC.decisionPageInfiniteLoader.dataProd),
            hhsPriceClass = '.ph-final-price-hhs',
            finalPriceClass = hhsPriceClass;

        if (isOneStore === 'true') {
          if ($this.find(pcmsPriceClass).length > 0) {
            finalPriceClass = pcmsPriceClass;
          }
        }

        if (result.salesOrg) {
          var prodSalesOrg = $this.find('.' + ACC.decisionPageInfiniteLoader.prodSearchName).attr(ACC.decisionPageInfiniteLoader.prodSalesOrg);

          if ((result.salesOrg === prodSalesOrg) && (result.code === ctn)) {
            ACC.decisionPageInfiniteLoader.lazyLoadListingPageHhsMainSubFunction(finalPriceClass, $this, result, cardResponse);
            $this.removeClass('ph-lazyloaded-item');

            return false;
          }
        } else if (result.code === ctn) {
          ACC.decisionPageInfiniteLoader.lazyLoadListingPageHhsMainSubFunction(finalPriceClass, $this, result, cardResponse);
          $this.removeClass('ph-lazyloaded-item');

          return false;
        }

        return true;
      });
    },

    lazyLoadListingPageHhsMainSubFunction: function(finalPriceClass, $this, result, cardResponse) {
      var havePrice = false,
          isConfigurableProduct = false;

      havePrice = ACC.decisionPageInfiniteLoader.lazyLoadListingPageHhsSubFunction($this, result, finalPriceClass);

      cardResponse.forEach(function(data) {
        if (result.code === data.code) {
          isConfigurableProduct = ACC.decisionPageInfiniteLoader.identifyConfigurableItem(data);
        }
      });

      ACC.decisionPageInfiniteLoader.ajaxHhsPcms($this, result);
      ACC.decisionPageInfiniteLoader.renderAddtocartButtonHhs(result, $this[0], havePrice, isConfigurableProduct);
      ACC.pdppricelazyload.substitutionMessage($this.find('.ph-substitution'), result);
    },

    lazyLoadListingPageHhs: function(cardResponse) {
      var $decisionPageCard = $('#' + ACC.decisionPageInfiniteLoader.decisionpageCards),
          hhsPriceClass = '.ph-final-price-hhs',
          contentType = 'application/x-www-form-urlencoded',
          isFinalPriceClassPresent = $decisionPageCard.find(hhsPriceClass).length > 0;

      if (isOneStore === 'true') {
        isFinalPriceClassPresent = $decisionPageCard.find(hhsPriceClass).length > 0 || $decisionPageCard.find(pcmsPriceClass).length > 0;
      }

      if (isFinalPriceClassPresent) {
        var prodList = [],
            priceUrl = '/lazyload/gethhspricedata',
            ajaxdataObj = {},
            lazyLoadClasses = ACC.decisionPageInfiniteLoader.lazyLoadedItemClass + '.ph-lazyloaded-pricecall',
            lazyLoadedElements = $('#' + ACC.decisionPageInfiniteLoader.decisionpageCards).find(lazyLoadClasses);

        lazyLoadedElements.each(function() {
          if (isOneStore === 'true') {
            var currObj = {
                  salesOrg: ''
                },
                currObjsalesOrg = $(this).find('.ph-productname').attr(ACC.decisionPageInfiniteLoader.prodSalesOrg),
                currObjmultiSalesOrg = $(this).find('.ph-decisionpage__content').attr('data-availableinsalesorg');

            currObj.code = $(this).find('.' + ACC.decisionPageInfiniteLoader.prodSearchName).attr(ACC.decisionPageInfiniteLoader.dataProd);

            if (currObjsalesOrg) {
              currObj.salesOrg = currObjsalesOrg;
            }

            if (currObjmultiSalesOrg) {
              currObj.availableInSalesOrg = currObjmultiSalesOrg;
            }

            prodList.push(currObj);
          } else {
            prodList.push($(this).find('.' + ACC.decisionPageInfiniteLoader.prodSearchName).attr(ACC.decisionPageInfiniteLoader.dataProd));
          }
        });

        if (isOneStore === 'true') {
          priceUrl = '/lazyload/getPriceList';
          ajaxdataObj = JSON.stringify({
            productList: prodList
          });
          contentType = 'application/json';
        } else {
          ajaxdataObj = {
            codes: prodList.toString()
          };
        }

        $('#' + ACC.decisionPageInfiniteLoader.decisionpageCards).find(ACC.decisionPageInfiniteLoader.lazyLoadedItemClass).removeClass('ph-lazyloaded-pricecall');

        $.ajax({
          type: 'POST',
          url: ACC.config.contextPath + priceUrl,
          contentType: contentType,
          data: ajaxdataObj,
          success: function(results) {
            ACC.decisionPageInfiniteLoader.priceCallResponse(results, cardResponse);
          },
          error: function() {
            lazyLoadedElements.each(function() {
              $(this).removeClass('ph-lazyloaded-item');
            });
          }
        });
      }
    },
    priceCallResponse: function(results, cardResponse) {
      var atpProdCodes = [];

      results.forEach(function(result) {
        if (result.price && result.price.value && result.price.value > 0) {
          atpProdCodes.push({
            prodCode: result.code,
            salesOrg: result.salesOrg
          });
          $('#decisionpageitem' + result.code).find(atpMsgDiv).removeClass('hidden');
        }

        ACC.decisionPageInfiniteLoader.lazyLoadListingPageHhsMainFunction(result, cardResponse);

        if (result.isConfigitEnabled) {
          ACC.configit.plpConfigitButton(result.code, result.salesOrg);
        }

        ACC.decisionPageInfiniteLoader.handleDuplicateProdCode(result);
      });

      if (isOneStore === 'true') {
        ACC.decisionPageInfiniteLoader.atpCallAfterPrice(atpProdCodes);
      }
    },
    renderDuplicateHandle: function($decisionpageCards, $product) {
      if ($product.availableInSalesOrg) {
        var decisionpageitemElem = $decisionpageCards.find('#decisionpageitem' + $product.code),
            hiddedClass = 'hiddens availableInOtherSalesOrg';

        decisionpageitemElem.find('.ph-product-summaryinfo,.ph-productname').addClass(hiddedClass);
        decisionpageitemElem.find('.ph-decisionpage__content').attr('data-availableinsalesorg', $product.availableInSalesOrg);
      }
    },
    handleDuplicateImage: function(availableInSalesOrg, itemElem, product) {
      if (!product.imageURL && itemElem.find('.ph-decisionpage__image img').attr('data-srcurl')) {
        product.imageURL = itemElem.find('.ph-decisionpage__image img').attr('data-srcurl');
      }

      if (availableInSalesOrg && product.imageURL) {
        itemElem.find('.ph-decisionpage__image img').attr('src', product.imageURL);
      }

      if (availableInSalesOrg && product.salesOrg) {
        itemElem.find('.ph-product-salesOrg').val(product.salesOrg);
      }

      if (availableInSalesOrg && product.isSpProduct) {
        itemElem.find('.ph-product-isSpProduct').val(product.isSpProduct);
      }
    },
    handleDuplicateProdCode: function(product) {
      var $itemElem = $('#decisionpageitem' + product.code),
          availableInSalesOrg = $itemElem.find('.ph-decisionpage__content').attr('data-availableinsalesorg');

      if (product.isAvailableForBothCatalogs) {
        $itemElem.find('.ph-isAvailableForBothCatalogs').val(product.isAvailableForBothCatalogs);
      }

      if (availableInSalesOrg && product.summary) {
        $itemElem.find('.ph-product-summaryinfo').removeClass('hidden').text(product.summary);
      }

      if (availableInSalesOrg && $.trim(product.prxProductName) && $.trim(product.prxProductName) !== product.summary) {
        $itemElem.find('.ph-productname').removeClass('hidden').text($.trim(product.prxProductName));
      } else if (availableInSalesOrg && $.trim(product.name) && $.trim(product.name) !== product.summary) {
        $itemElem.find('.ph-productname').removeClass('hidden').text($.trim(product.name));
      }

      ACC.decisionPageInfiniteLoader.handleDuplicateImage(availableInSalesOrg, $itemElem, product);
    },
    atpCallAfterPrice: function(atpProdCodes) {
      var prodList = [],
          prodlistClass = '.prod_list';

      atpProdCodes.forEach(function(atpProdObj) {
        var currObj = {
              salesOrg: '',
              code: atpProdObj.prodCode
            },
            isApproved = $('#' + ACC.decisionPageInfiniteLoader.decisionpageitem + atpProdObj.prodCode)
              .find(prodlistClass).attr('data-approval'),
            currObjsalesOrg = $('#' + ACC.decisionPageInfiniteLoader.decisionpageitem + atpProdObj.prodCode)
              .find(prodlistClass).attr(ACC.decisionPageInfiniteLoader.prodSalesOrg);

        if (atpProdObj.salesOrg) {
          currObj.salesOrg = atpProdObj.salesOrg;
        }

        if (currObj.salesOrg === '' && currObjsalesOrg) {
          currObj.salesOrg = currObjsalesOrg;
        }

        if (isApproved && isApproved === 'approved') {
          prodList.push(currObj);
        }
      });
      ACC.decisionPageInfiniteLoader.fetchAtpDetails(prodList);
    },
    estDeliveryHhsResultDate: function(resultData) {
      var estDelHhsDate = resultData,
          deliveryDateValue = '',
          instockDeliveryRange = String($('.ph-atpvar-instockDeliveryRange').text()),
          outofstockMessage = $('.ph-outofstock-message').text();

      if (String(estDelHhsDate.philipsATPData) !== 'null' && String(estDelHhsDate.philipsATPData.isProductInStock) === 'true') {
        if (estDelHhsDate.philipsATPData.estimateDeliveryDate !== null && estDelHhsDate.philipsATPData.estimateDeliveryDate !== '') {
          deliveryDateValue = instockDeliveryRange + '&nbsp;&nbsp;' + estDelHhsDate.philipsATPData.estimateDeliveryDate;
          $('#' + ACC.decisionPageInfiniteLoader.decisionpageCards).find('#' + ACC.decisionPageInfiniteLoader.decisionpageitem +
          estDelHhsDate.code).find(atpMsgDiv).html('<p class="strong ph-atpmessage">' +
          deliveryDateValue + '</p>');
        }
      } else if (String(estDelHhsDate.philipsATPData) !== 'null') {
        if (String(estDelHhsDate.philipsATPData.isProductInStock) === 'false' || String(estDelHhsDate.philipsATPData.availableQuantity) === '0.0') {
          $('#' + ACC.decisionPageInfiniteLoader.decisionpageCards).find('#' + ACC.decisionPageInfiniteLoader.decisionpageitem +
          estDelHhsDate.code).find(atpMsgDiv).html('<p class="strong ph-atpmessage">' +
          outofstockMessage + '</p>');
        }
      }
    },
    hidePriceForUser: function(tmpl) {
      var showPrice = $('.ph-showprice').val(),
          disabledVal = 'false',
          showWishList = $('.ph-showwishlist').val();

      if (String(showPrice) === disabledVal) {
        tmpl.querySelector('.ph-decisionpage__qtyholder').remove();
        tmpl.querySelector('.ph-decisionpage__addtocarholder').remove();
      }

      if (String(showWishList) === disabledVal) {
        tmpl.querySelector('.ph-decisionpage__addtoshoppinglistholder').remove();
      }
    },
    fetchAtpDetails: function(prodList) {
      var ajaxdataObj = {};

      if (prodList.length > 0 && $('.ph-checkATPEnabled').html() === 'true') {
        if (isOneStore === 'true') {
          ajaxdataObj = {
            productList: prodList
          };
        } else {
          ajaxdataObj = {
            codes: prodList.toString()
          };
        }

        $.ajax({
          type: 'POST',
          url: ACC.config.contextPath + '/lazyload/getATPDetails.json',
          contentType: 'application/json',
          data: JSON.stringify(ajaxdataObj),
          success: function(result) {
            if (result) {
              $.each(result, function(key, val) {
                var $inputObj = $('#decisionpageCards .ph-decisionpage__card input[name="productCodePost"][value=' + val.code + ']'),
                    parentObj = $inputObj.parents('.ph-decisionpage__card');

                if (val.salesOrg) {
                  $inputObj = $('#decisionpageCards #decisionpageitem' + val.code + ' .ph-productname[data-salesorg=' + val.salesOrg + ']');
                  parentObj = $inputObj.parents('.ph-decisionpage__card');
                }

                val.isAtpCall = true;

                ACC.decisionPageInfiniteLoader.decisionPageAtpMsg(parentObj[0], val);
              });
            }
          }
        });
      }
    }
  };
  window.addEventListener('DOMContentLoaded', function() {
    if ($('#decisionpageCards').length > 0 && $('.ph-decisionpage__cards').length > 0) {
      ACC.decisionPageInfiniteLoader.bindAll();
    }

    $(document).on('click', '.ph-anonyAddToCartAnchor', function() {
      var anonyAddToCartLink = String($(this).attr('href'));

      window.gaclkFn.anonymousAddToCart(anonyAddToCartLink);
    });

    $(document).on('click', '.ph-shoppinglistRdo', function() {
      $(this).attr('id', 'ph-shoppinglistRdo-' + $(this).parents('.ph-addtoshoppinglist').attr('data-productcode'));
    });

    if ($('.ph-introjsvalue').text() === 'true' && (($('.ph-page-search').length > 0) || ($('.ph-page-productList').length > 0))) {
      if ($('.ph-showIntroToUser').text() === 'true') {
        var $introstep = $('.ph-icon-heart-bordered'),
            introheader = $introstep.attr('data-introheader'),
            introtext = $introstep.attr('data-introtext'),
            introFavicon = '<div class="ph-introjs__header ph-plp-introheader">' + introheader + '</div><div class="ph-introjs__text ph-plp-introtext">' + introtext + '</div>',
            $introfavouriteicon = $('.ph-decisionpage__cards .ph-decisionpage__addtoshoppinglistholder:first');

        $introfavouriteicon.attr('data-step', $introstep.attr('data-stepNumber'));
        $introfavouriteicon.attr('data-intro', introFavicon);
      }
    }

    $(document).on('click', '.ph-omnitureaddshoplist', function() {
      var linkValue = 'product_' + $(this).attr('data-productcode');

      if ($('.ph-page-productDetails').length > 0) {
        linkValue = '';
      }

      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'button',
        sectionValue: 'add_to_wishlist',
        linkValue: linkValue
      });
    });
    $(document).on('click', '.ph-savetomylistpdp', function() {
      var linkValue = '',
          productCodeText = 'product_' + $(this).find('.ph-savetolistBtn').attr('data-productcode');

      if (productCodeText) {
        linkValue = productCodeText;
      }

      if ($('.ph-page-productDetails').length > 0) {
        linkValue = '';
      }

      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'button',
        sectionValue: 'save_to_wishlist',
        linkValue: linkValue
      });
    });
    $(document).on('click', '.ph-filter-wrapper .ph-filter input[type=checkbox]', function() {
      var linkValue = 'uncheck',
          sectionValue = 'product_category',
          categoryCodeText = $(this).val();

      if (categoryCodeText) {
        sectionValue = sectionValue + ':' + categoryCodeText;
      }

      if ($(this).is(':checked')) {
        linkValue = 'check';
      }

      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'filter',
        sectionValue: sectionValue,
        linkValue: linkValue
      });
    });
  });
})();
